import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 0,
  class: "mb-64"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-24" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h5" }, " The Boundary ")
], -1 /* HOISTED */)
const _hoisted_4 = { class: "grid grid--xs flex flex--wrap flex--align-start" }
const _hoisted_5 = {
  key: 0,
  class: "grid__item a4-12 d6-6 mb-16"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-8" }, " Business Development Director ", -1 /* HOISTED */)
const _hoisted_7 = {
  key: 1,
  class: "grid__item a4-12 d6-6 mb-16"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-8" }, " Client Services ", -1 /* HOISTED */)
const _hoisted_9 = {
  key: 2,
  class: "grid__item a4-12 d6-6 mb-16"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-8" }, " Project Manager ", -1 /* HOISTED */)
const _hoisted_11 = {
  key: 3,
  class: "grid__item a4-12 d6-6 mb-16"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-8" }, " Lead Artist ", -1 /* HOISTED */)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-8" }, " Artists ", -1 /* HOISTED */)
const _hoisted_15 = { class: "grid grid--xs flex flex--wrap" }
const _hoisted_16 = {
  key: 0,
  class: "grid__item a4-12 d6-6"
}
const _hoisted_17 = {
  key: 1,
  class: "mb-64"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "mb-24" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h5" }, " Clients & Partners ")
], -1 /* HOISTED */)
const _hoisted_19 = { class: "directory-table" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("th", null, "Name", -1 /* HOISTED */)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("th", null, "Position", -1 /* HOISTED */)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("th", null, "Company", -1 /* HOISTED */)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", null, "Email", -1 /* HOISTED */)
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["href"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 0,
  class: "directory-table__notifications-on"
}
const _hoisted_28 = {
  key: 1,
  class: "directory-table__notifications-off"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PageLoaderComponent = _resolveComponent("PageLoaderComponent")
  const _component_DirectoryCardComponent = _resolveComponent("DirectoryCardComponent")
  const _component_AddUserModalComponent = _resolveComponent("AddUserModalComponent")

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      ($data.loading)
        ? (_openBlock(), _createBlock(_component_PageLoaderComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            ($options.boundary_staff.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("div", _hoisted_4, [
                    ($options.business_development || ( $props.project.project_status !== 'completed' && $props.project.project_status !== 'terminated' && ( $data.user_is_staff_admin || $data.user_is_staff_super_admin ) ))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _hoisted_6,
                          _createVNode(_component_DirectoryCardComponent, {
                            user: $options.business_development,
                            "user-type": $setup.USER_TYPE_BUSINESS_DEVELOPMENT,
                            onAddUsers: $options.openAddUserModal
                          }, null, 8 /* PROPS */, ["user", "user-type", "onAddUsers"])
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($options.client_services || ( $props.project.project_status !== 'completed' && $props.project.project_status !== 'terminated' && ( $data.user_is_staff_admin || $data.user_is_staff_super_admin ) ))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _hoisted_8,
                          _createVNode(_component_DirectoryCardComponent, {
                            user: $options.client_services,
                            "user-type": $setup.USER_TYPE_client_services,
                            onAddUsers: $options.openAddUserModal
                          }, null, 8 /* PROPS */, ["user", "user-type", "onAddUsers"])
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($options.project_manager || ( $props.project.project_status !== 'completed' && $props.project.project_status !== 'terminated' && ( $data.user_is_staff_admin || $data.user_is_staff_super_admin ) ))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _hoisted_10,
                          _createVNode(_component_DirectoryCardComponent, {
                            user: $options.project_manager,
                            "user-type": $setup.USER_TYPE_PROJECT_MANAGER,
                            onAddUsers: $options.openAddUserModal
                          }, null, 8 /* PROPS */, ["user", "user-type", "onAddUsers"])
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($options.lead_artist || ( $props.project.project_status !== 'completed' && $props.project.project_status !== 'terminated' && ( $data.user_is_staff_admin || $data.user_is_staff_super_admin ) ))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _hoisted_12,
                          _createVNode(_component_DirectoryCardComponent, {
                            user: $options.lead_artist,
                            "user-type": $setup.USER_TYPE_LEAD_ARTIST,
                            onAddUsers: $options.openAddUserModal
                          }, null, 8 /* PROPS */, ["user", "user-type", "onAddUsers"])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  ($options.project_artists.length || ( $props.project.project_status !== 'completed' && $props.project.project_status !== 'terminated' && ( $data.user_is_staff_admin || $data.user_is_staff_super_admin ) ))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("ul", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.project_artists, (user) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: user.id,
                              class: "grid__item a4-12 d6-6"
                            }, [
                              _createVNode(_component_DirectoryCardComponent, {
                                user: user,
                                "user-type": $setup.USER_TYPE_ARTIST,
                                "hide-email": true
                              }, null, 8 /* PROPS */, ["user", "user-type"])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          ($props.project.project_status !== 'completed' && $props.project.project_status !== 'terminated' && ( $data.user_is_staff_admin || $data.user_is_staff_super_admin ))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                                _createVNode(_component_DirectoryCardComponent, {
                                  user: null,
                                  "user-type": $setup.USER_TYPE_ARTIST,
                                  onAddUsers: $options.openAddUserModal
                                }, null, 8 /* PROPS */, ["user-type", "onAddUsers"])
                              ]))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            ($options.clients.length || ( $props.project.project_status !== 'completed' && $props.project.project_status !== 'terminated' && ( $data.user_is_staff_admin || $data.user_is_staff_super_admin ) ))
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("table", null, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_20,
                          _hoisted_21,
                          _hoisted_22,
                          _hoisted_23,
                          ($props.project.project_status !== 'completed' && $props.project.project_status !== 'terminated' && ( $data.user_is_staff_admin || $data.user_is_staff_super_admin ))
                            ? (_openBlock(), _createElementBlock("th", _hoisted_24, " Email Notifications "))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.clients, (user) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: user.id,
                            class: "directory-table__row"
                          }, [
                            _createElementVNode("td", null, _toDisplayString(user.fullName), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString(user.user_role), 1 /* TEXT */),
                            _createElementVNode("td", null, [
                              (user.company.length)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(user.company[0].title), 1 /* TEXT */)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("a", {
                                href: `mailto:${user.email}`
                              }, _toDisplayString(user.email), 9 /* TEXT, PROPS */, _hoisted_25)
                            ]),
                            ($data.user_is_staff_admin || $data.user_is_staff_super_admin)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_26, [
                                  ($options.userHasNotificationsOn( user ))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, " On "))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_28, " Off "))
                                ]))
                              : _createCommentVNode("v-if", true)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]),
                    ($props.project.project_status !== 'completed' && $props.project.project_status !== 'terminated' && ( $data.user_is_staff_admin || $data.user_is_staff_super_admin ))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "directory-table__add-user",
                          onClick: _cache[0] || (_cache[0] = $event => ($options.openAddUserModal( $setup.USER_TYPE_CLIENT )))
                        }, " Add client or partner "))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  ($data.active_user_type && $options.user_list && $data.show_user_modal)
                    ? (_openBlock(), _createBlock(_component_AddUserModalComponent, {
                        key: 0,
                        project: $props.project,
                        "user-type": $data.active_user_type,
                        "user-list": $options.user_list,
                        loading: $data.loading_user_update,
                        errors: $data.errors,
                        "error-message": $data.error_message,
                        onAddUsersToProject: $options.addUsersToProject,
                        onCloseModal: $options.closeAddUserModal
                      }, null, 8 /* PROPS */, ["project", "user-type", "user-list", "loading", "errors", "error-message", "onAddUsersToProject", "onCloseModal"]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              })
            ]))
          ]))
    ]),
    _: 1 /* STABLE */
  }))
}